import AppHeader from '../AppHeader'
import DayJs from 'dayjs'

export default {
  name: 'evaluate-question-detail',
  created () {
    this.getEvaluateQuestionDetail()
    this.$store.dispatch('USERTYPE_ALL_GET', {})
    this.getNormalQuestions()
    this.getPersonnelQuestions()
    this.getBusinessQuestions()
  },
  data () {
    return {
      title: '',
      userType: null,
      normalQuestions: [],
      normalQuestionId: '',
      selectedNormalQuestion: null,
      personnelQuestions: [],
      personnelQuestionId: '',
      selectedPersonnelQuestion: null,
      businessQuestions: [],
      businessQuestionId: '',
      selectedBusinessQuestion: null,
      isOwnNormalQuestion: false,
      isOwnPersonnelQuestion: false,
      isOwnBusinessQuestion: false,
      evaluateNormalAnswerUserTypeIds: [],
      evaluatePersonnelAnswerUserTypeIds: [],
      evaluateBusinessAnswerUserTypeIds: [],
      notificationStartDate: '',
      answerStartDate: '',
      endDate: '',
      endDateRange: this.answerStartDateFormat < this.endDateFormat,
      joinRestrictionDate: '',
      shopRestrictionDate: '',
      getEvaluateQuestionDetailEnd: false
    }
  },
  computed: {
    userTypeName () {
      const userType = this.$store.getters.usertypesAll.find(userType => parseInt(userType.id) === this.userType)
      return userType ? userType.attributes['user-type-name'] : ''
    },
    normalQuestionName () {
      const normalQuestion = this.normalQuestions.find(normalQuestion => parseInt(normalQuestion.id) === this.normalQuestionId)
      return normalQuestion ? normalQuestion.title : ''
    },
    personnelQuestionName () {
      const personnelQuestion = this.personnelQuestions.find(personnelQuestion => parseInt(personnelQuestion.id) === this.personnelQuestionId)
      return personnelQuestion ? personnelQuestion.title : ''
    },
    businessQuestionName () {
      const businessQuestion = this.businessQuestions.find(businessQuestion => parseInt(businessQuestion.id) === this.businessQuestionId)
      return businessQuestion ? businessQuestion.title : ''
    },
    ownQuestionSlashSeparated () {
      const isOwnQuestionObj = {
        normal: {
          label: '常態評価',
          isOwn: this.isOwnNormalQuestion
        },
        personnel: {
          label: '個人スキル評価',
          isOwn: this.isOwnPersonnelQuestion
        },
        business: {
          label: '業務スキル評価',
          isOwn: this.isOwnBusinessQuestion
        }
      }
      let result = ''
      let no = true
      for (let i = 0; i < Object.keys(isOwnQuestionObj).length; i++) {
        const value = Object.values(isOwnQuestionObj)[i]
        if (value.isOwn) {
          result += value.label
          no = false
        }
        if (i + 1 !== Object.keys(isOwnQuestionObj).length) {
          const nextValue = Object.values(isOwnQuestionObj)[i + 1]
          if (nextValue.isOwn) {
            result += ' / '
          }
        }
      }
      return no ? 'なし' : result
    },
    joinRestrictionDateFormat () {
      return DayJs(this.joinRestrictionDate).format('YYYY年MM月DD日')
    },
    shopRestrictionDateFormat () {
      return DayJs(this.shopRestrictionDate).format('YYYY年MM月DD日')
    },
    notificationStartDateFormat () {
      return DayJs(this.notificationStartDate).format('YYYY年MM月DD日')
    },
    answerStartDateFormat () {
      return DayJs(this.answerStartDate).format('YYYY年MM月DD日')
    },
    endDateFormat () {
      return DayJs(this.endDate).format('YYYY年MM月DD日')
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getEvaluateQuestionDetail () {
      let res = await this.$store.dispatch('GET_EVALUATE_QUESTION_DETAIL', { id: this.$route.params.id })
      .catch(err => {
        console.log(err)
        return
      })
      const question = res.questions.data.attributes
      this.title = question.title
      this.userType = question['target-user-type-id']
      this.normalQuestionId = question['evaluate-normal-question-id']
      this.personnelQuestionId = question['evaluate-personal-question-id']
      this.businessQuestionId = question['evaluate-business-question-id']
      this.notificationStartDate = question['notification-start-date']
      this.answerStartDate = question['answer-start-date']
      this.endDate = question['answer-end-date']
      this.shopRestrictionDate = question['shop-restriction-date']
      this.joinRestrictionDate = question['join-restriction-date']
      this.evaluateNormalAnswerUserTypeIds = question['evaluate-normal-answer-user-types'].map(obj => obj['target_user_type_id'])
      this.evaluatePersonnelAnswerUserTypeIds = question['evaluate-personal-answer-user-types'].map(obj => obj['target_user_type_id'])
      this.evaluateBusinessAnswerUserTypeIds = question['evaluate-business-answer-user-types'].map(obj => obj['target_user_type_id'])
      this.isOwnNormalQuestion = question['is-own-normal-question']
      this.isOwnPersonnelQuestion = question['is-own-personal-question']
      this.isOwnBusinessQuestion = question['is-own-business-question']
      this.getEvaluateQuestionDetailEnd = true
    },
    async getNormalQuestions () {
      let data = {}
      await this.$store.dispatch('GET_NORMAL_QUESTION_ALL', { data })
      .then(res => {
        this.normalQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async getPersonnelQuestions () {
      let data = {}
      await this.$store.dispatch('GET_PERSONNEL_QUESTION_ALL', { data })
      .then(res => {
        this.personnelQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    async getBusinessQuestions () {
      let data = {}
      await this.$store.dispatch('GET_BUSINESS_QUESTION_ALL', { data })
      .then(res => {
        this.businessQuestions = res.questions
      })
      .catch(err => {
        console.log(err)
        return
      })
    },
    getTypeName (userTypeId) {
      const userType = this.$store.getters.usertypesAll.find(userType => parseInt(userType.id) === userTypeId)
      return userType ? userType.attributes['user-type-name'] : ''
    },
    goNormalQuestionDetail () {
      this.$router.push('/normal_question/' + this.normalQuestionId)
    },
    goPersonnelQuestionDetail () {
      this.$router.push('/ability_question/' + this.personnelQuestionId)
    },
    goBusinessQuestionDetail () {
      this.$router.push('/ability_question/' + this.businessQuestionId)
    },
    goBack: function () {
      this.$router.push('/evaluate_question_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-question-detail.js